
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jXEWW", function(module, exports) {

$parcel$export(module.exports, "useAutomationPermissionService", () => $6f0e82fa07f9b2c3$export$54caaf01d4d48f4e);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $j1Ss3 = parcelRequire("j1Ss3");

var $1JEqL = parcelRequire("1JEqL");
const $6f0e82fa07f9b2c3$export$54caaf01d4d48f4e = (spaceKey)=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const skipQuery = !spaceKey || Boolean(undefined); // indexAutomationAdminQuery isn't preloaded and can be skipped during SSR to avoid unnecessary requests
    const { data: data, error: error } = (0, $j1Ss3.useQuery)((0, $d2LG0.default)`query indexAutomationAdminQuery($spaceKey:String!){user(current:true){id confluence{operations{operation targetType}}}isSiteAdmin hasUserAccessAdminRole space(key:$spaceKey){id currentUser{isAdmin}}}`, {
        variables: {
            spaceKey: spaceKey
        },
        skip: skipQuery
    });
    const isSpaceAdmin = data?.space?.currentUser?.isAdmin ?? false;
    const isProductOrSiteAdmin = (0, $1JEqL.getIsProductOrSiteAdminFromQuery)(data);
    return {
        canManageAutomations: isSpaceAdmin || isProductOrSiteAdmin,
        error: error
    };
};

});

parcelRegister("1fOao", function(module, exports) {

$parcel$export(module.exports, "useAutomationMenu", () => $e1d1978ef947919e$export$9e222d3b7ca4dc6f);
$parcel$export(module.exports, "ConfluenceManualRulesContainer", () => $e1d1978ef947919e$export$235166e539b0088a);
// This is another layer on top of the AFE ManualRulesContainer.
// It is necessary that this container wraps the entire "automation" component and not nested. Else the user input form will not render correctly.
// This container provides an automation context to all children components through the useAutomationMenu hook.

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $bHPHO = parcelRequire("bHPHO");

var $0B4xj = parcelRequire("0B4xj");

var $dIouf = parcelRequire("dIouf");

var $7aRa9 = parcelRequire("7aRa9");

var $bQm3c = parcelRequire("bQm3c");

var $awcJz = parcelRequire("awcJz");

var $71D5r = parcelRequire("71D5r");
const $e1d1978ef947919e$var$AutomationMenuContext = /*#__PURE__*/ (0, $gwFzn.createContext)(undefined);
const $e1d1978ef947919e$var$AutomationMenuProvider = ({ children: children, value: value })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e1d1978ef947919e$var$AutomationMenuContext.Provider, {
        value: value
    }, children);
};
const $e1d1978ef947919e$export$9e222d3b7ca4dc6f = ()=>{
    const context = (0, $gwFzn.useContext)($e1d1978ef947919e$var$AutomationMenuContext);
    if (context === undefined) throw new Error('useAutomationMenu must be used within a AutomationMenuProvider');
    return context;
};
const $e1d1978ef947919e$var$i18n = (0, $2nPZH.defineMessages)({
    ruleInvocationSuccessTitle: {
        id: "automation-menu.flag.invocation.success.title",
        defaultMessage: "Your automation is in progress"
    },
    ruleInvocationFailureTitle: {
        id: "automation-menu.flag.invocation.failure.title",
        defaultMessage: "Oops we ran into a problem"
    },
    ruleInvocationFailureDescription: {
        id: "automation-menu.flag.invocation.failure.description",
        defaultMessage: "There was a problem and we couldn\u2019t run the automation"
    }
});
const $e1d1978ef947919e$export$235166e539b0088a = (0, $7aRa9.withFlags)(({ flags: flags, analyticsSource: analyticsSource, aris: aris, spaceKey: spaceKey, children: children, onRuleInvocationLifecycleDone: onRuleInvocationLifecycleDone, singleSpace: singleSpace })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const mappedEnvironment = (0, $71D5r.mapEnv)(environment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $0B4xj.ManualRulesContainer), {
        env: mappedEnvironment,
        site: (0, $bHPHO.ConfluenceSiteAri).create({
            siteId: cloudId
        }).toString(),
        query: {
            //if all pages are in same space, we only need one ari
            objects: singleSpace ? aris.slice(0, 1).map(String) : aris.map(String)
        },
        onRuleInvocationLifecycleDone: onRuleInvocationLifecycleDone,
        onRuleInvocationSuccess: ()=>{
            flags.hideFlag('automation-manual-trigger-execution-queued-flag').then(()=>flags.showInfoFlag({
                    id: 'automation-manual-trigger-execution-finished-flag',
                    title: formatMessage($e1d1978ef947919e$var$i18n.ruleInvocationSuccessTitle),
                    isAutoDismiss: true
                }));
        },
        onRuleInvocationFailure: ()=>{
            flags.hideFlag('automation-manual-trigger-execution-queued-flag').then(()=>flags.showErrorFlag({
                    id: 'automation-manual-trigger-execution-finished-flag',
                    title: formatMessage($e1d1978ef947919e$var$i18n.ruleInvocationFailureTitle),
                    description: formatMessage($e1d1978ef947919e$var$i18n.ruleInvocationFailureDescription),
                    isAutoDismiss: true
                }));
        }
    }, (props)=>{
        const baseAutomationUrl = (0, $awcJz.getBaseAutomationUrl)({
            spaceKey: spaceKey
        });
        const contextValue = {
            ...props,
            analyticsSource: analyticsSource,
            aris: aris,
            baseAutomationUrl: baseAutomationUrl,
            spaceKey: spaceKey
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
            attribution: (0, $dIouf.Attribution).AUTOMATION_FOR_CONFLUENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($e1d1978ef947919e$var$AutomationMenuProvider, {
            value: contextValue
        }, children()));
    });
});

});
parcelRegister("0B4xj", function(module, exports) {

$parcel$export(module.exports, "ManualRulesContainer", () => $3dc9b564e50a41bb$export$eb0a81e78d942dba);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $RUXAI = parcelRequire("RUXAI");

var $6xdDU = parcelRequire("6xdDU");

var $9Begw = parcelRequire("9Begw");

var $fpK0a = parcelRequire("fpK0a");
const $3dc9b564e50a41bb$export$96513fc6544cb4e5 = (env, site, query)=>{
    const [initialised, setInitialised] = (0, $gwFzn.useState)(false);
    const [error, setError] = (0, $gwFzn.useState)(null);
    const [rules, setRules] = (0, $gwFzn.useState)([]);
    const transformRules = (ruleResponse)=>{
        const rulesUnsorted = Object.values(ruleResponse);
        return rulesUnsorted.sort((rule1, rule2)=>rule1.name.localeCompare(rule2.name));
    };
    const triggerFetch = async ()=>{
        setInitialised(false);
        try {
            const fetchedRules = await (0, $9Begw.searchManuallyTriggeredRules)(env, site, query);
            setError(null);
            setRules(transformRules(fetchedRules));
        } catch (e) {
            setError(e);
            setRules([]);
        } finally{
            setInitialised(true);
        }
    };
    return [
        triggerFetch,
        initialised,
        error,
        rules
    ];
};
const $3dc9b564e50a41bb$export$eb0a81e78d942dba = (props)=>{
    (0, $RUXAI.di)((0, $6xdDU.default), (0, $fpK0a.default), (0, $9Begw.invokeManuallyTriggeredRule), $3dc9b564e50a41bb$export$96513fc6544cb4e5, (0, $gwFzn.useMemo), (0, $gwFzn.useState));
    const { env: env, site: site, query: query, children: children, onInputsModalOpened: onInputsModalOpened, onInputsModalClosed: onInputsModalClosed, onRuleInvocationLifecycleStarted: onRuleInvocationLifecycleStarted, onRuleInvocationSuccess: onRuleInvocationSuccess, onRuleInvocationFailure: onRuleInvocationFailure, onRuleInvocationLifecycleDone: onRuleInvocationLifecycleDone } = props;
    // Initial data loading state
    const [triggerFetch, initialised, error, rules] = $3dc9b564e50a41bb$export$96513fc6544cb4e5(env, site, query);
    // We store a rule in state here if and only if a rule has user inputs, and thus
    // we need to preserve state while the input dialog is open.
    const [selectedRule, setSelectedRule] = (0, $gwFzn.useState)(null);
    const clearSelectedRule = ()=>{
        setSelectedRule(null);
    };
    // Value set when a rule is invoking, either from the dialog or without dialog
    const [invokingRuleId, setInvokingRuleId] = (0, $gwFzn.useState)(null);
    // Memoized projection of rules by id
    const rulesById = (0, $gwFzn.useMemo)(()=>rules.reduce((acc, rule)=>({
                // eslint-disable-next-line
                ...acc,
                [rule.id]: rule
            }), {}), [
        rules
    ]);
    const getRule = (id)=>rulesById[id];
    const ruleHasInputs = (rule)=>rule?.userInputPrompts?.length > 0;
    const INVOCATIONS = 'invocations';
    const SUCCESS = 'SUCCESS';
    const getFailedObjects = (response)=>Object.keys(response).filter((object)=>object !== INVOCATIONS && response[object] !== SUCCESS);
    const getSuccessfulObjects = (response)=>Object.keys(response).filter((object)=>object !== INVOCATIONS && response[object] === SUCCESS);
    const handleInvocationFailure = (ruleId, successfulObjects, failedObjects)=>{
        if (onRuleInvocationFailure) onRuleInvocationFailure(ruleId, successfulObjects, failedObjects);
    };
    const invokeRule = async (ruleId, objects, userInputs)=>{
        const rule = getRule(ruleId);
        if (rule) {
            setInvokingRuleId(ruleId);
            try {
                if (onRuleInvocationLifecycleStarted) onRuleInvocationLifecycleStarted(ruleId, objects, userInputs);
                const response = await (0, $9Begw.invokeManuallyTriggeredRule)(env, site, ruleId, objects, userInputs);
                const failedObjects = getFailedObjects(response);
                setInvokingRuleId(null);
                if (failedObjects.length === 0) {
                    if (onRuleInvocationSuccess) onRuleInvocationSuccess(ruleId, objects);
                } else {
                    const successfulObjects = getSuccessfulObjects(response);
                    handleInvocationFailure(ruleId, successfulObjects, failedObjects);
                }
            } catch (e) {
                handleInvocationFailure(ruleId, [], objects);
                setInvokingRuleId(null);
            }
        } else handleInvocationFailure(ruleId, [], objects);
        clearSelectedRule();
        if (onRuleInvocationLifecycleDone) onRuleInvocationLifecycleDone(ruleId, objects);
    };
    const invokeRuleOrShowDialog = (ruleId, objects)=>{
        const rule = getRule(ruleId);
        if (!rule) return handleInvocationFailure(ruleId, [], objects);
        if (ruleHasInputs(rule)) setSelectedRule({
            rule: rule,
            objects: objects
        });
        else invokeRule(ruleId, objects);
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            children({
                triggerFetch: triggerFetch,
                initialised: initialised,
                error: error,
                rules: rules,
                invokingRuleId: invokingRuleId,
                invokeRuleOrShowDialog: invokeRuleOrShowDialog
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6xdDU.default), {
                children: selectedRule && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fpK0a.default), {
                    onInputsModalOpened: onInputsModalOpened,
                    onInputsModalClosed: onInputsModalClosed,
                    clearSelectedRule: clearSelectedRule,
                    selectedRule: selectedRule,
                    invokeRule: invokeRule
                })
            })
        ]
    });
};

});
parcelRegister("9Begw", function(module, exports) {

$parcel$export(module.exports, "searchManuallyTriggeredRules", () => $66d0663e92004e81$export$11e317ae81dd4223);
$parcel$export(module.exports, "invokeManuallyTriggeredRule", () => $66d0663e92004e81$export$9a0eb4136c6b46c);

var $4srqz = parcelRequire("4srqz");
const $66d0663e92004e81$export$11e317ae81dd4223 = async (env, site, query)=>{
    const url = await (0, $4srqz.getSearchUrl)(env, site);
    // TODO this will in the new API be a GET request instead, with the above getSearchUrl method
    // constructing a URL with the appropriate query parameters. For now, instead, we pass the
    // destructured query through as a POST body.
    const response = await (0, $4srqz.performPostRequest)(url, {
        body: JSON.stringify(query)
    });
    return response.reduce((acc, { id: id, name: name, ruleScope: ruleScope, userInputs: userInputs })=>({
            // eslint-disable-next-line
            ...acc,
            [id]: {
                id: id,
                name: name,
                ruleScope: ruleScope,
                userInputPrompts: userInputs
            }
        }), {});
};
const $66d0663e92004e81$export$9a0eb4136c6b46c = async (env, site, ruleId, objects, userInputs)=>{
    const url = await (0, $4srqz.getInvocationUrl)(env, site, ruleId);
    const bodyRaw = {
        objects: objects
    };
    if (userInputs) bodyRaw.userInputs = userInputs;
    return (0, $4srqz.performPostRequest)(url, {
        body: JSON.stringify(bodyRaw)
    });
};

});
parcelRegister("4srqz", function(module, exports) {

$parcel$export(module.exports, "getSearchUrl", () => $5f10a0d24e5e0ad1$export$7d4675b206f57488);
$parcel$export(module.exports, "getInvocationUrl", () => $5f10a0d24e5e0ad1$export$e62dcf5e32cec4bf);
$parcel$export(module.exports, "performPostRequest", () => $5f10a0d24e5e0ad1$export$692a4d9808143175);

var $dh538 = parcelRequire("dh538");

var $fRK8K = parcelRequire("fRK8K");

var $g0I84 = parcelRequire("g0I84");
const $5f10a0d24e5e0ad1$export$1cb1c6bd5a8f1613 = (site)=>{
    let cloudId;
    let resourceOwner;
    let resourceType;
    try {
        const ari = (0, $fRK8K.ResourceIdentifier).parse(site);
        cloudId = ari.cloudId;
        resourceOwner = ari.resourceOwner;
        resourceType = ari.resourceType;
        // Keep backwards compatibility for platform site ARIs
        if (resourceOwner === 'platform') resourceOwner = 'jira';
    } catch (error) {
        throw new Error('Attempted to parse malformed ARI: ' + site);
    }
    if (resourceType !== 'site' || cloudId === undefined) throw new Error('Not a site ARI: ' + site);
    return {
        product: resourceOwner,
        cloudId: cloudId
    };
};
const $5f10a0d24e5e0ad1$export$7d4675b206f57488 = async (env, site)=>{
    const { product: product, cloudId: cloudId } = $5f10a0d24e5e0ad1$export$1cb1c6bd5a8f1613(site);
    const automationStack = await (0, $g0I84.getAutomationStack)(env, cloudId);
    // TODO in the unified API, GET requests as according to Atlassian API standards will destructure the whole query into
    // query parameters as part of the URL. For now, this is considered a POST request instead and thus the query is used
    // later on as the request body.
    return `/gateway/api/automation/internal-api/${product}/${cloudId}/${automationStack}/rest/v1/rules/manual/search`;
};
const $5f10a0d24e5e0ad1$export$e62dcf5e32cec4bf = async (env, site, ruleId)=>{
    const { product: product, cloudId: cloudId } = $5f10a0d24e5e0ad1$export$1cb1c6bd5a8f1613(site);
    const automationStack = await (0, $g0I84.getAutomationStack)(env, cloudId);
    return `/gateway/api/automation/internal-api/${product}/${cloudId}/${automationStack}/rest/v1/rules/manual/invocation/${ruleId}`;
};
const $5f10a0d24e5e0ad1$var$DEFAULT_HEADER = {
    'Content-Type': 'application/json'
};
const $5f10a0d24e5e0ad1$var$_performRequest = async (url, method, options = {
    headers: $5f10a0d24e5e0ad1$var$DEFAULT_HEADER
})=>{
    const response = await fetch(url, {
        ...options,
        method: method
    });
    return response.json();
};
const $5f10a0d24e5e0ad1$export$4a53ae1be8ec80c7 = async (url, options)=>{
    return $5f10a0d24e5e0ad1$var$_performRequest(url, 'GET', options);
};
const $5f10a0d24e5e0ad1$export$692a4d9808143175 = async (url, options)=>{
    return $5f10a0d24e5e0ad1$var$_performRequest(url, 'POST', options);
};
const $5f10a0d24e5e0ad1$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if (projectType === 'customer_service' && (0, $dh538.fg)('jcs_project_type_m3')) return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
    switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});
parcelRegister("g0I84", function(module, exports) {

$parcel$export(module.exports, "getAutomationStack", () => $257b51498dbf0a52$export$6123178d3f5fb24d);
const $257b51498dbf0a52$var$AUTOMATION_LOCAL_STORAGE_PREFIX = 'automationPlatform';
const $257b51498dbf0a52$var$AUTOMATION_LOCAL_STORAGE_STACK = 'automationStack';
const $257b51498dbf0a52$var$AUTOMATION_DEV_STACK_URL = 'https://localhost:8082/devStack.json';
const $257b51498dbf0a52$var$getAutomationProdStackUrl = (cloudId)=>`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`;
const $257b51498dbf0a52$var$getLatestPreProdStack = async (cloudId)=>{
    try {
        const response = await fetch($257b51498dbf0a52$var$getAutomationProdStackUrl(cloudId));
        const stacksResponse = await response.json();
        const preProdStacks = stacksResponse.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        const [latestPreProdStack = null] = preProdStacks;
        return latestPreProdStack;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch pre-prod stack from ${$257b51498dbf0a52$var$getAutomationProdStackUrl(cloudId)} with error: ${e}`);
        return null;
    }
};
const $257b51498dbf0a52$var$_getAutomationKeyFromLocalStorage = (key)=>{
    return window.localStorage.getItem(`${$257b51498dbf0a52$var$AUTOMATION_LOCAL_STORAGE_PREFIX}:${key}`);
};
const $257b51498dbf0a52$var$getAutomationDevStackFromLocalServer = async ()=>{
    try {
        const devStackResponse = await fetch($257b51498dbf0a52$var$AUTOMATION_DEV_STACK_URL);
        const devStack = await devStackResponse.json();
        return devStack.name;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch dev stack from ${$257b51498dbf0a52$var$AUTOMATION_DEV_STACK_URL} with error: ${e}`);
        return null;
    }
};
const $257b51498dbf0a52$export$48cdb3ba720a47f6 = ()=>$257b51498dbf0a52$var$_getAutomationKeyFromLocalStorage($257b51498dbf0a52$var$AUTOMATION_LOCAL_STORAGE_STACK);
const $257b51498dbf0a52$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') return 'pro';
    if (env === 'pre-prod') {
        const stack = await $257b51498dbf0a52$var$getLatestPreProdStack(cloudId);
        return stack ?? 'pro';
    }
    // We fetch the dev stack name from local server (barrel webpack dev server) if it's available.
    // However, this requires that devWatch is running locally.
    // To use manual triggers without running devWatch, set the local storage value to your stack name e.g. devltan3. The full key is: automationPlatform:automationStack
    const stackOverride = await $257b51498dbf0a52$var$getAutomationDevStackFromLocalServer() || $257b51498dbf0a52$export$48cdb3ba720a47f6();
    return stackOverride || 'staging';
};

});



parcelRegister("fpK0a", function(module, exports) {

$parcel$export(module.exports, "default", () => $be85f4683a10666c$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $RUXAI = parcelRequire("RUXAI");

var $ccHMk = parcelRequire("ccHMk");

var $fzqvY = parcelRequire("fzqvY");
var $gQhRa = parcelRequire("gQhRa");
var $3eD0p = parcelRequire("3eD0p");

var $ekolh = parcelRequire("ekolh");
var $1DHa6 = parcelRequire("1DHa6");
var $8o1lj = parcelRequire("8o1lj");
var $9ot3w = parcelRequire("9ot3w");
var $d8eRd = parcelRequire("d8eRd");

var $iB0Jl = parcelRequire("iB0Jl");

var $cSnD1 = parcelRequire("cSnD1");

var $jYpUz = parcelRequire("jYpUz");

var $js9mw = parcelRequire("js9mw");

var $eXP4H = parcelRequire("eXP4H");

var $ag8oA = parcelRequire("ag8oA");

var $7jE9X = parcelRequire("7jE9X");
const $be85f4683a10666c$export$a3f697c029ab2691 = (props)=>{
    (0, $RUXAI.di)((0, $jYpUz.default), (0, $ccHMk.default), (0, $gQhRa.ErrorMessage), (0, $fzqvY.default), (0, $3eD0p.default), (0, $ekolh.default), (0, $1DHa6.default), (0, $8o1lj.default), (0, $9ot3w.default), (0, $d8eRd.default), (0, $js9mw.default), (0, $ag8oA.default), (0, $7jE9X.default));
    const { selectedRule: selectedRule, clearSelectedRule: clearSelectedRule, invokeRule: invokeRule, onInputsModalOpened: onInputsModalOpened, onInputsModalClosed: onInputsModalClosed } = props;
    const { rule: rule, objects: objects } = selectedRule;
    const { userInputPrompts: userInputPrompts } = rule;
    const getTypeOfInput = (key, prompts)=>prompts.find(({ variableName: variableName })=>variableName === key)?.inputType;
    const generateInputValue = (inputType, data)=>{
        switch(inputType){
            case (0, $cSnD1.UserInputType).DROPDOWN:
                return {
                    inputType: inputType,
                    value: data ? data.value : ''
                };
            case (0, $cSnD1.UserInputType).NUMBER:
                return {
                    inputType: inputType,
                    value: Number(data)
                };
            default:
                return {
                    inputType: inputType,
                    value: data
                };
        }
    };
    const handleSubmit = (data)=>{
        const output = Object.entries(data).reduce((acc, [key, value])=>{
            const inputType = getTypeOfInput(key, userInputPrompts);
            if (!inputType) return acc;
            acc[key] = generateInputValue(inputType, value);
            return acc;
        }, {});
        return invokeRule(rule.id, objects, output);
    };
    const handleOpen = ()=>{
        if (onInputsModalOpened) onInputsModalOpened();
    };
    const handleClose = ()=>{
        clearSelectedRule();
        if (onInputsModalClosed) onInputsModalClosed();
    };
    const generateUserInputForm = (inputPrompt)=>{
        switch(inputPrompt.inputType){
            case (0, $cSnD1.UserInputType).TEXT:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7jE9X.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $cSnD1.UserInputType).NUMBER:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $js9mw.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $cSnD1.UserInputType).DROPDOWN:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ag8oA.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $cSnD1.UserInputType).BOOLEAN:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jYpUz.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $cSnD1.UserInputType).PARAGRAPH:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eXP4H.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            default:
                return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("br", {}),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gQhRa.ErrorMessage), {
                            children: (0, $iB0Jl.default).errorInputTypeIsNotSupported.defaultMessage
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("br", {})
                    ]
                });
        }
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ekolh.default), {
        "data-testid": "automation-platform.ui.manual-rules-container.manual-triggers-form.modal",
        onClose: handleClose,
        onOpenComplete: handleOpen,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fzqvY.default), {
            onSubmit: handleSubmit,
            children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $7UHDa.jsxs)("form", {
                    ...formProps,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9ot3w.default), {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d8eRd.default), {
                                children: rule.name
                            })
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1DHa6.default), {
                            children: [
                                (0, $iB0Jl.default).inputRequiredForAction.defaultMessage,
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3eD0p.default), {
                                    children: userInputPrompts.map(generateUserInputForm)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $8o1lj.default), {
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                                    appearance: "subtle",
                                    onClick: handleClose,
                                    isDisabled: submitting,
                                    children: (0, $iB0Jl.default).cancelButtonTitle.defaultMessage
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isLoading: submitting,
                                    autoFocus: true,
                                    children: (0, $iB0Jl.default).continueButtonTitle.defaultMessage
                                })
                            ]
                        })
                    ]
                })
        })
    });
};
var $be85f4683a10666c$export$2e2bcd8739ae039 = $be85f4683a10666c$export$a3f697c029ab2691;

});
parcelRegister("iB0Jl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58bb86fd209f1a14$export$2e2bcd8739ae039);
const $58bb86fd209f1a14$var$messages = {
    successFlag: {
        id: 'automation-platform.common.success-flag',
        defaultMessage: 'Your automation is in progress',
        description: 'Text for a success flag when an automation rule has been triggered'
    },
    failureFlagTitle: {
        id: 'automation-platform.common.failure-flag-title',
        defaultMessage: 'Oops we ran into a problem',
        description: 'Title for an error flag when an automation rule failed to be triggered'
    },
    failureFlagDescription: {
        id: 'automation-platform.common.failure-flag-description',
        defaultMessage: "There was a problem and we couldn't run the automation '{0}'",
        description: 'Description for an error flag when an automation rule failed to be triggered'
    },
    partialFailureFlagDescription: {
        id: 'automation-platform.common.partial-failure-flag-description',
        defaultMessage: "Couldn't run the automation against issues {0}, please ensure you have permission to view these issues",
        description: 'Description for an error flag when some issues failed to invoke because user does not have view permission'
    },
    errorInputMustNotBeEmpty: {
        id: 'automation-platform.common.error-input-must-not-be-empty',
        defaultMessage: 'Input must not be empty',
        description: 'The error message to show the value of a required field is empty'
    },
    errorInputCharacterLimitReached: {
        id: 'automation-platform.common.error-input-character-limit-reached',
        defaultMessage: 'Provided value exceeds the character limit for the field.',
        description: 'The error message to show that the character limit has been reached for the field'
    },
    inputRequiredForAction: {
        id: 'automation-platform.common.input-required-for-action',
        defaultMessage: 'Your input is required to complete this action',
        description: 'The title of the modal for user inputs'
    },
    errorInputTypeIsNotSupported: {
        id: 'automation-platform.common.error-input-type-is-not-supported',
        defaultMessage: 'Input type not supported yet',
        description: 'The error message to show when the type of user input is not recognised'
    },
    errorValueIsNotValidNumber: {
        id: 'automation-platform.common.error-value-is-not-valid-number',
        defaultMessage: 'The value is not a valid number',
        description: 'The error message for when the type of user input is number but the value is not a valid number'
    },
    cancelButtonTitle: {
        id: 'automation-platform.common.cancel-button-title',
        defaultMessage: 'Cancel',
        description: 'The cancel button title'
    },
    continueButtonTitle: {
        id: 'automation-platform.common.continue-button-title',
        defaultMessage: 'Continue',
        description: 'The continue button title'
    }
};
var $58bb86fd209f1a14$export$2e2bcd8739ae039 = $58bb86fd209f1a14$var$messages;

});

parcelRegister("cSnD1", function(module, exports) {

$parcel$export(module.exports, "UserInputType", () => $2e786fc3a725eb31$export$955ccc93b55d5904);
var $2e786fc3a725eb31$export$955ccc93b55d5904 = /*#__PURE__*/ function(UserInputType) {
    UserInputType["NUMBER"] = "NUMBER";
    UserInputType["TEXT"] = "TEXT";
    UserInputType["BOOLEAN"] = "BOOLEAN";
    UserInputType["DROPDOWN"] = "DROPDOWN";
    UserInputType["PARAGRAPH"] = "PARAGRAPH";
    return UserInputType;
}({});
const $2e786fc3a725eb31$export$4b79f735ed858abe = 'business';
const $2e786fc3a725eb31$export$417275bac62d38d2 = 'software';
const $2e786fc3a725eb31$export$9c9c9eaf8c092006 = 'service_desk';
const $2e786fc3a725eb31$export$e9fe9a39cc7f5103 = 'product_discovery';
const $2e786fc3a725eb31$export$e9c56aa3b027d98f = 'customer_service';

});

parcelRegister("jYpUz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d57249674e1928bc$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $RUXAI = parcelRequire("RUXAI");

var $7gpC4 = parcelRequire("7gpC4");

var $6rSJC = parcelRequire("6rSJC");
const $d57249674e1928bc$var$BooleanInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $RUXAI.di)((0, $7gpC4.default), (0, $6rSJC.default));
    const { variableName: variableName, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6rSJC.default), {
        name: variableName,
        defaultIsChecked: defaultValue || false,
        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7gpC4.default), {
                ...fieldProps,
                label: displayName
            })
    });
};
var $d57249674e1928bc$export$2e2bcd8739ae039 = $d57249674e1928bc$var$BooleanInputPrompt;

});

parcelRegister("js9mw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ca042666076337$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $RUXAI = parcelRequire("RUXAI");

var $gQhRa = parcelRequire("gQhRa");
var $fb3kw = parcelRequire("fb3kw");

var $4noo5 = parcelRequire("4noo5");

var $iB0Jl = parcelRequire("iB0Jl");
var $b9ca042666076337$export$b8e9cd941e8016ac = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    Errors["INVALID_NUMBER"] = "INVALID_NUMBER";
    return Errors;
}({});
const $b9ca042666076337$export$c6cbc3bbef9e5a54 = (isRequired, value)=>{
    if (isRequired && !value) return "EMPTY";
    if (value && Number.isNaN(Number(value))) return "INVALID_NUMBER";
    return undefined;
};
const $b9ca042666076337$var$NumberInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $RUXAI.di)((0, $gQhRa.ErrorMessage), (0, $fb3kw.default), (0, $4noo5.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const generateErrorMessage = (error)=>{
        switch(error){
            case "EMPTY":
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gQhRa.ErrorMessage), {
                    children: (0, $iB0Jl.default).errorInputMustNotBeEmpty.defaultMessage
                });
            case "INVALID_NUMBER":
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gQhRa.ErrorMessage), {
                    children: (0, $iB0Jl.default).errorValueIsNotValidNumber.defaultMessage
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fb3kw.default), {
        "aria-required": required,
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: (value)=>$b9ca042666076337$export$c6cbc3bbef9e5a54(required, value),
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4noo5.default), {
                        ...fieldProps
                    }),
                    generateErrorMessage(error)
                ]
            })
    }, variableName);
};
var $b9ca042666076337$export$2e2bcd8739ae039 = $b9ca042666076337$var$NumberInputPrompt;

});

parcelRegister("eXP4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $33686cdbcd59ec20$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $RUXAI = parcelRequire("RUXAI");

var $gQhRa = parcelRequire("gQhRa");
var $fb3kw = parcelRequire("fb3kw");

var $9EtP6 = parcelRequire("9EtP6");

var $iB0Jl = parcelRequire("iB0Jl");
var $33686cdbcd59ec20$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    Errors["CHARACTER_LIMIT"] = "CHARACTER_LIMIT";
    return Errors;
}($33686cdbcd59ec20$var$Errors || {});
const $33686cdbcd59ec20$var$MAX_PARAGRAPH_CHARACTER_LIMIT = 5000;
const $33686cdbcd59ec20$var$ParagraphInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $RUXAI.di)((0, $gQhRa.ErrorMessage), (0, $fb3kw.default), (0, $9EtP6.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>{
        if (required && !value) return "EMPTY";
        if (value && value?.trim().length === 0) return "EMPTY";
        if (value && value.length > $33686cdbcd59ec20$var$MAX_PARAGRAPH_CHARACTER_LIMIT) return "CHARACTER_LIMIT";
        return undefined;
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fb3kw.default), {
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: validate,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9EtP6.default), {
                        ...fieldProps
                    }),
                    error === "EMPTY" && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gQhRa.ErrorMessage), {
                        children: (0, $iB0Jl.default).errorInputMustNotBeEmpty.defaultMessage
                    }),
                    error === "CHARACTER_LIMIT" && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gQhRa.ErrorMessage), {
                        children: (0, $iB0Jl.default).errorInputCharacterLimitReached.defaultMessage
                    })
                ]
            })
    });
};
var $33686cdbcd59ec20$export$2e2bcd8739ae039 = $33686cdbcd59ec20$var$ParagraphInputPrompt;

});

parcelRegister("ag8oA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d969a0131b921f31$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $RUXAI = parcelRequire("RUXAI");

var $gQhRa = parcelRequire("gQhRa");
var $fb3kw = parcelRequire("fb3kw");

var $2gD2K = parcelRequire("2gD2K");

var $iB0Jl = parcelRequire("iB0Jl");
var $d969a0131b921f31$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    return Errors;
}($d969a0131b921f31$var$Errors || {});
const $d969a0131b921f31$var$SelectInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $RUXAI.di)((0, $gQhRa.ErrorMessage), (0, $fb3kw.default), (0, $2gD2K.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>{
        if (required && !value) return "EMPTY";
        return undefined;
    };
    const selectOptions = defaultValue.map((value)=>({
            label: value,
            value: value
        }));
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fb3kw.default), {
        name: variableName,
        label: displayName,
        isRequired: required,
        validate: validate,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2gD2K.default), {
                        isClearable: true,
                        isSearchable: true,
                        options: selectOptions,
                        menuPosition: "fixed",
                        ...fieldProps
                    }),
                    error === "EMPTY" && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gQhRa.ErrorMessage), {
                        children: (0, $iB0Jl.default).errorInputMustNotBeEmpty.defaultMessage
                    })
                ]
            })
    });
};
var $d969a0131b921f31$export$2e2bcd8739ae039 = $d969a0131b921f31$var$SelectInputPrompt;

});

parcelRegister("7jE9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c4484a0ac3321a8$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $RUXAI = parcelRequire("RUXAI");

var $gQhRa = parcelRequire("gQhRa");
var $fb3kw = parcelRequire("fb3kw");

var $4noo5 = parcelRequire("4noo5");

var $iB0Jl = parcelRequire("iB0Jl");
var $1c4484a0ac3321a8$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    return Errors;
}($1c4484a0ac3321a8$var$Errors || {});
const $1c4484a0ac3321a8$var$TextInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $RUXAI.di)((0, $gQhRa.ErrorMessage), (0, $fb3kw.default), (0, $4noo5.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>required && !value ? "EMPTY" : undefined;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fb3kw.default), {
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: validate,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4noo5.default), {
                        ...fieldProps
                    }),
                    error === "EMPTY" && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gQhRa.ErrorMessage), {
                        children: (0, $iB0Jl.default).errorInputMustNotBeEmpty.defaultMessage
                    })
                ]
            })
    });
};
var $1c4484a0ac3321a8$export$2e2bcd8739ae039 = $1c4484a0ac3321a8$var$TextInputPrompt;

});



parcelRegister("awcJz", function(module, exports) {

$parcel$export(module.exports, "getBaseAutomationUrl", () => $4bac0f7515b59602$export$8e479e490e1e69bc);
const $4bac0f7515b59602$export$8e479e490e1e69bc = ({ spaceKey: spaceKey })=>{
    return `/wiki/spaces/${spaceKey}/settings/automation`;
};

});

parcelRegister("71D5r", function(module, exports) {

$parcel$export(module.exports, "mapEnv", () => $abcb2d5b68c96c49$export$2f2beb3dfc4bcd87);

var $9wGTI = parcelRequire("9wGTI");
const $abcb2d5b68c96c49$export$2f2beb3dfc4bcd87 = (env)=>{
    switch(env){
        case 'DEVELOPMENT':
            return 'dev';
        case 'PRODUCTION':
            return (0, $9wGTI.fg)('automation-dev-helper') ? 'pre-prod' : 'prod';
        case 'STAGING':
            return 'staging';
        default:
            return 'local';
    }
};

});


parcelRegister("kT5zt", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $f8bed93993cee5a0$export$8f31e4c4a37b8e9c);
/* Skeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f8bed93993cee5a0$var$AutomationSkeletonContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1yt4x7n9",
            __cmplp.className
        ])
    });
});
const $f8bed93993cee5a0$var$SkeletonContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_18s813su _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $f8bed93993cee5a0$var$SkeletonIcon = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rkov77o _19it1lf1 _1bsbpxbi _4t3ipxbi _1e0c1o8l _bfhk1r31 _tzy4nh7s",
            __cmplp.className
        ])
    });
});
const $f8bed93993cee5a0$var$MenuIcon = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $f8bed93993cee5a0$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f8bed93993cee5a0$var$SkeletonText = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsb13sl _4t3ipxbi _19pk1b66 _18u0utpp _5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkn82g _1itkfzvv _12vemgnk",
            __cmplp.className
        ])
    });
});
const $f8bed93993cee5a0$var$SkeletonLine = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f8bed93993cee5a0$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f8bed93993cee5a0$var$MenuIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f8bed93993cee5a0$var$SkeletonIcon, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f8bed93993cee5a0$var$SkeletonText, null));
const $f8bed93993cee5a0$var$getSkeletonLines = (lineCount)=>{
    const skeletonLines = [];
    for(let i = 0; i < lineCount; i++)skeletonLines.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f8bed93993cee5a0$var$SkeletonLine, {
        key: `skeleton-line-${i}`
    }));
    return skeletonLines;
};
const $f8bed93993cee5a0$export$8f31e4c4a37b8e9c = (props)=>{
    const { lineCount: lineCount = 5 } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f8bed93993cee5a0$var$AutomationSkeletonContainer, null, $f8bed93993cee5a0$var$getSkeletonLines(lineCount));
};

});

parcelRegister("Ij2L0", function(module, exports) {

$parcel$export(module.exports, "ManualTriggerIcon", () => $637dceea82563eb1$export$1ba9c8c8d09e7b3f);

var $gwFzn = parcelRequire("gwFzn");

var $d6Fdl = parcelRequire("d6Fdl");
const $637dceea82563eb1$export$1ba9c8c8d09e7b3f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d6Fdl.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "m21.192 19.778-4.9498-4.9498c-0.3905-0.3905-1.0237-0.3905-1.4142 0-0.3905 0.3906-0.3905 1.0237 0 1.4143l4.9498 4.9497c0.3905 0.3905 1.0237 0.3905 1.4142 0s0.3905-1.0237 0-1.4142z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "m8.7738 8.1319 11.685 4.305c0.2591 0.0955 0.3917 0.3829 0.2963 0.6421-0.025 0.0679-0.0645 0.1295-0.1156 0.1807l-7.3802 7.3801c-0.1952 0.1953-0.5118 0.1953-0.7071 0-0.0511-0.0512-0.0906-0.1128-0.1156-0.1807l-4.3051-11.685c-0.09546-0.25911 0.03721-0.54656 0.29632-0.64202 0.11157-0.0411 0.23414-0.0411 0.34571 0z",
        clipRule: "evenodd",
        fill: "currentColor",
        fillRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        d: "m4.2218 4.2218c1.9526-1.9526 5.1184-1.9526 7.0711 0 0.5977 0.59776 1.0125 1.3092 1.2443 2.0648 0.1974 0.6437-0.4389 1.1502-1.0873 0.96899l-0.2172-0.06069c-0.3475-0.09709-0.6037-0.38008-0.7563-0.70702-0.1439-0.30836-0.3432-0.59728-0.59773-0.85184-1.1716-1.1716-3.0711-1.1716-4.2426 0-1.1716 1.1716-1.1716 3.0711 0 4.2426 0.2547 0.25469 0.54381 0.45399 0.85236 0.59799 0.32725 0.1527 0.61051 0.4091 0.70752 0.7569l0.06045 0.2168c0.18082 0.6483-0.32561 1.2843-0.96914 1.087-0.75578-0.2317-1.4675-0.6466-2.0654-1.2445-1.9526-1.9526-1.9526-5.1184 0-7.071z",
        clipRule: "evenodd",
        fill: "currentColor",
        fillRule: "evenodd"
    }));

});

parcelRegister("3KUzn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8cbf4ab2d75c385e37fe01f50c4f5b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2bc18c843d1b28df$var$_react = $2bc18c843d1b28df$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $2bc18c843d1b28df$var$_baseNew = $2bc18c843d1b28df$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $2bc18c843d1b28df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PresenterMode".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for presenter mode in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2bc18c843d1b28df$var$PresenterModeIcon = (props)=>/*#__PURE__*/ $2bc18c843d1b28df$var$_react.default.createElement($2bc18c843d1b28df$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.909 2.5a2.409 2.409 0 0 0-1.054 4.576l-.657 1.348a3.909 3.909 0 1 1 5.226-5.226l-1.348.657A2.41 2.41 0 0 0 4.909 2.5m-.19 2.22a.75.75 0 0 1 .786-.175l9 3.25a.75.75 0 0 1 .02 1.403l-3.822 1.505-1.505 3.822a.75.75 0 0 1-1.403-.02l-3.25-9a.75.75 0 0 1 .175-.785M6.5 6.498l2.032 5.629.896-2.277a.75.75 0 0 1 .423-.423l2.276-.896z" clip-rule="evenodd"/>`
    }, props));
$2bc18c843d1b28df$var$PresenterModeIcon.displayName = 'PresenterModeIcon';
var $2bc18c843d1b28df$var$_default = module.exports.default = $2bc18c843d1b28df$var$PresenterModeIcon;

});


//# sourceMappingURL=RendererContentStateWithSpotlight.173338fc.js.map
